<template>
  <span class="client application-rating" :style="cssColors">
    <fieldset v-if="!readonly && isManager">
      <template
        v-for="star in [5.0, 4.5, 4.0, 3.5, 3.0, 2.5, 2.0, 1.5, 1.0, 0.5]"
      >
        <input
          :id="`${application.id}-star-${star}`"
          type="radio"
          :value="star * 2"
          :checked="star * 2 === rating"
          :key="`${application.id}-star-${star}-input`"
          @click.stop=""
        />
        <label
          :for="`${application.id}-star-${star}`"
          :class="{ 'star--half': star % 1 != 0 }"
          :key="`${application.id}-star-${star}-label`"
          @click.stop=""
        >
          <v-icon @click.stop="confirmRating(star * 2)">mdi-star</v-icon>
        </label>
      </template>
    </fieldset>
    <span v-else class="readonly-rating">
      <template
        v-for="star in [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0]"
      >
        <span
          :key="star"
          class="mdi hover-off"
          :class="{ 'star--half': star % 1 != 0 }"
        >
          <v-icon
            :color="
              rating / 2 >= star ? themes.client.light.input : 'grey lighten-3'
            "
          >
            mdi-star
          </v-icon>
        </span>
      </template>
    </span>
    <v-dialog :value="confirming" width="350px" persistent>
      <v-card>
        <v-card-text>
          <div class="subheading">
            Save {{ application.profile.firstName }}
            {{ application.profile.lastName }}'s new rating?
          </div>
          <div class="text-xs-center">
            <span>New rating is </span>
            <span v-if="stars >= 0">
              <v-icon
                v-for="s in stars"
                :key="`${s}-star`"
                :color="themes.client.light.input"
                >mdi-star</v-icon
              >
              <v-icon
                class="half"
                :color="themes.client.light.input"
                v-if="rating % 2 !== 0"
                >mdi-star</v-icon
              >
            </span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="cancel">Cancel</v-btn>
          <v-btn @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import colors from "@/data/colors";

export default {
  props: { application: Object, readonly: { type: Boolean, default: false } },
  data() {
    return {
      rating: JSON.parse(JSON.stringify(this.application.applicationRating)),
      doos: 0,
      confirming: false,
      colors,
    };
  },
  computed: {
    cssColors() {
      return {
        "--star-color": this.colors.deepOrange.lighten1,
        "--star-color-active": this.LightenDarkenColor(
          this.colors.deepOrange.lighten1,
          50
        ),
        "--star-color-inactive": this.colors.grey.lighten3,
      };
    },

    stars() {
      return parseInt(this.rating / 2);
    },

    isManager() {
      return this.$store.getters["client/opportunities/currentIsManager"]();
    },
  },
  watch: {
    "application.applicationRating": function (rating) {
      this.rating = rating;
    },
  },
  methods: {
    confirmRating(newRating = 0) {
      this.rating = newRating;
      this.confirming = this.application.applicationRating !== newRating;
    },

    cancel() {
      this.confirming = false;
      this.rating = JSON.parse(
        JSON.stringify(this.application.applicationRating)
      );
    },

    save() {
      this.confirming = false;
      this.$http
        .post("client/application_ratings", {
          application: this.application.id,
          rating: this.rating,
        })
        .then(
          (response) => {
            this.$store.dispatch("snackbarSuccess", "Rating Saved");
            return this.$store.dispatch("client/applications/fetch", {
              id: this.application.id,
            });
          },
          (errors) => {
            this.$store.dispatch("snackbarError", "Rating Failed");
            this.rating = JSON.parse(
              JSON.stringify(this.application.applicationRating)
            );
          }
        );
    },

    LightenDarkenColor(col, amt) {
      var usePound = false;

      if (col[0] == "#") {
        col = col.slice(1);
        usePound = true;
      }

      var num = parseInt(col, 16);

      var r = (num >> 16) + amt;

      if (r > 255) r = 255;
      else if (r < 0) r = 0;

      var b = ((num >> 8) & 0x00ff) + amt;

      if (b > 255) b = 255;
      else if (b < 0) b = 0;

      var g = (num & 0x0000ff) + amt;

      if (g > 255) g = 255;
      else if (g < 0) g = 0;

      return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    },
  },
};
</script>

<style lang="scss">
span.client.application-rating fieldset {
  position: absolute;
  display: inline-block;
  padding: 0;
  border: none;
}

span.client.application-rating input {
  display: none;
}

span.client.application-rating label {
  float: right;
  font-size: 0;
}

span.client.application-rating label > i:before {
  content: "\F04CE";
  font-size: 24px;
  color: var(--star-color-inactive);
}

span.client.application-rating label:hover ~ label > i:before,
span.client.application-rating label:hover > i:before,
span.client.application-rating {
  content: "\F04CE";
  color: var(--star-color-active);
  transition: 0.2s;
}

span.client.application-rating input:checked ~ label > i:before {
  content: "\F04CE";
  color: var(--star-color);
}

span.client.application-rating input:checked ~ label:hover > i:before,
span.client.application-rating input:checked ~ label:hover ~ label > i:before {
  color: var(--star-color-active);
  transition: 0.2s;
}

/* Half-star*/
span.client.application-rating .star--half {
  position: relative;
}

span.client.application-rating .star--half > i {
  position: absolute;
  padding-right: 0;
  -webkit-clip-path: polygon(0 0, 50% 0, 50% 100%, 0% 100%);
  clip-path: polygon(0 0, 50% 0, 50% 100%, 0% 100%);
}

span.client.application-rating .star--half:hover > i:before {
  content: "\F04CE";
}
</style>
